import type { PropsWithChildren } from "react";

export const Container = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <div className="bg-primary absolute left-0 top-0 z-50 size-full">
    {children}
  </div>
);
